import React, { useState } from 'react';
import { buildApiUrl } from '../../config/api';

const getOriginalFileName = (url) => {
  // Extract filename from URL
  const parts = url.split('/');
  const fileName = parts[parts.length - 1];
  // Remove any query parameters
  return fileName.split('?')[0];
};

const AssetList = ({ assets, setAssets, isUploading, formatFileSize, getOriginalFileName, onSelectAsset }) => {
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [deletingAssetId, setDeletingAssetId] = useState(null);

  const handleSettingsClick = (asset) => {
    setSelectedAsset(asset);
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === 'asset-details-overlay') {
      setSelectedAsset(null);
    }
  };

  const handleDeleteAsset = async (assetId) => {
    setDeletingAssetId(assetId);
    setSelectedAsset(null); // Close the popup immediately

    try {
      const response = await fetch(
        buildApiUrl(`api/projects/6755092eebddd53b8a71cb89/assets/${assetId}`),
        {
          method: 'DELETE',
        }
      );

      if (response.ok) {
        // Remove the asset from the array
        setAssets(prevAssets => prevAssets.filter(asset => asset._id !== assetId));
      } else {
        console.error('Failed to delete asset');
      }
    } catch (error) {
      console.error('Error deleting asset:', error);
    } finally {
      setDeletingAssetId(null);
    }
  };

  return (
    <>
      <div className="assets-list">
        {isUploading && (
          <div className="asset-wrapper">
            <div className="asset-item loading">
              <div className="image-container">
                <div className="loading-spinner"></div>
                <div className="loading-success hidden">
                  <span>✓</span>
                </div>
              </div>
            </div>
            <div className="asset-info">
              <span className="asset-filename">Uploading...</span>
            </div>
          </div>
        )}

        {assets.map((asset) => (
          <div key={asset._id} className="asset-wrapper">
            <div className={`asset-item ${deletingAssetId === asset._id ? 'deleting' : ''}`}>
              <div className="image-container">
                {deletingAssetId === asset._id ? (
                  <div className="loading-spinner"></div>
                ) : (
                  <img 
                    src={asset.url} 
                    alt={getOriginalFileName(asset.url)}
                    title={getOriginalFileName(asset.url)}
                    onClick={() => onSelectAsset(asset)}
                  />
                )}
                {deletingAssetId !== asset._id && (
                  <button 
                    className="settings-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSettingsClick(asset);
                    }}
                  >
                    ⚙️
                  </button>
                )}
              </div>
            </div>
            <div className="asset-info">
              <span className="asset-filename">
                {deletingAssetId === asset._id ? 'Deleting...' : getOriginalFileName(asset.url)}
              </span>
              {asset.fileSize && deletingAssetId !== asset._id && (
                <span className="asset-size">{formatFileSize(asset.fileSize)}</span>
              )}
            </div>
          </div>
        ))}
      </div>

      {selectedAsset && (
        <div 
          className="asset-details-overlay"
          onClick={handleOverlayClick}
        >
          <div className="asset-details-popup">
            <div className="popup-header">
              <h3>Asset Details</h3>
              <button 
                className="close-button"
                onClick={() => setSelectedAsset(null)}
              >
                ��
              </button>
            </div>
            <div className="popup-content">
              <div className="detail-row">
                <label>File Name</label>
                <span>{getOriginalFileName(selectedAsset.url)}</span>
              </div>
              <div className="detail-row">
                <label>Dimensions</label>
                <span>{selectedAsset.dimensions.width} x {selectedAsset.dimensions.height}px</span>
              </div>
              <div className="detail-row">
                <label>Size</label>
                <span>{formatFileSize(selectedAsset.size)}</span>
              </div>
              <div className="detail-row">
                <label>Alt Text</label>
                <input
                  type="text"
                  value={selectedAsset.altText || ''}
                  onChange={(e) => {
                    // Handle alt text change
                  }}
                  placeholder="Enter alt text..."
                />
              </div>
              <button 
                className="delete-button"
                onClick={() => handleDeleteAsset(selectedAsset._id)}
              >
                Delete Asset
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssetList; 